const hideMenu = () => {
    document.body.classList.remove("mobile-nav-active");
};
export default hideMenu;
